var _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrades(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 128,
    r: 128,
    fill: "#111827"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 125,
    width: 25,
    height: 58,
    fill: "#1E263B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 106,
    width: 5,
    height: 96,
    fill: "#1E263B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 73,
    width: 26,
    height: 81,
    fill: "#4C5876"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 54,
    width: 4,
    height: 119,
    fill: "#4C5876"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 80,
    width: 4,
    height: 110,
    fill: "#4C5876"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 104,
    width: 26,
    height: 65,
    fill: "#4C5876"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrades);
export default __webpack_public_path__ + "static/media/trades.bcf1e5aecef34cd8bdff2a16cdd34b6b.svg";
export { ForwardRef as ReactComponent };